import React from 'react';

export function LocatorItemSectionCheckboxes({ items }: { items: Array<{ label: string }> }) {
	return (
		<div className="grid grid-cols-3 gap-x-6 gap-y-2 md:grid-cols-1">
			{items.map(item => (
				<div key={item.label} className="flex items-center gap-2">
					<div className="flex size-3.5 shrink-0 items-center justify-center rounded border border-green-700 bg-green-700">
						<svg className="size-2 text-white" fill="none" viewBox="0 0 10 10">
							<path d="M2 5l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<span className="text-sm text-gray-700">{item.label}</span>
				</div>
			))}
		</div>
	);
}
